export const BASE_API_URL = process.env.REACT_APP_SIA_API_URL;
export const headers = { 'Content-Type': 'application/json' };
